import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
const VALUES = [{
  label: 'Descarga inmediata',
  detail: 'Acceso al recurso justo después de la compra.'
}, {
  label: 'Formatos editables',
  detail: 'Archivos que podés adaptar a tu proyecto.'
}, {
  label: 'Temáticas variadas',
  detail: 'Una marca paraguas para distintos intereses.'
}, {
  label: 'Actualizaciones incluidas',
  detail: 'Mejoras del recurso sin costo extra.'
}];
const PILLARS = [{
  icon: ZapIcon,
  title: 'Implementación, no teoría',
  description: 'Cada producto incluye plantillas, guiones y pasos concretos. Nada de contenido para archivar.'
}, {
  icon: TrendingUpIcon,
  title: 'Pensado para aplicar',
  description: 'Diseñamos con foco en el resultado: entendés qué hacer y en qué orden hacerlo.'
}, {
  icon: ShieldCheckIcon,
  title: 'Calidad de estudio',
  description: 'Estética consistente, estructura clara y actualizaciones continuas.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function WhyUs() {
  return <section id="nosotros" className="relative w-full overflow-hidden border-t border-ink/[0.07] bg-paper-alt py-28 sm:py-32 lg:py-44" data-id="element-333" data-mp="3j7iev46e94lb">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-334" data-mp="3s384xqisen51">
        <div className="absolute left-1/2 top-1/4 h-[480px] w-[820px] -translate-x-1/2 rounded-full blur-[120px]" style={{
        background: 'radial-gradient(circle at 35% 40%, rgba(37,99,246,0.10), transparent 62%), radial-gradient(circle at 70% 60%, rgba(122,77,255,0.10), transparent 62%)'
      }} data-id="element-335" data-mp="wonhsig3yxr" />
      </div>

      <div className="relative mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-336" data-mp="2clfutd9i4v34">
        <div className="mx-auto max-w-3xl text-center" data-id="element-337" data-mp="2cn928urxvjc6">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-338" data-mp="2gm9koc6i8jyn">
            Por qué Creativo Digital
          </p>
          <h2 className="mt-7 text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-ink sm:text-[2.9rem]" data-id="element-339" data-mp="3k01ge2vc06nt">
            No vendemos información.
            <span className="mt-2 block gradient-text" data-id="element-340" data-mp="3syvig8rflp8r">
              Creamos herramientas para hacer crecer proyectos.
            </span>
          </h2>
        </div>

        <dl className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-341" data-mp="6rf4hqrf8z7c">
          {VALUES.map((value, i) => <motion.div key={value.label} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.07,
          ease
        }} className="rounded-3xl border border-ink/[0.07] bg-white p-8 shadow-soft sm:p-9" data-id="element-342" data-mp="1rao00qik4h4" data-mpi={i}>
              <span aria-hidden="true" className="block h-1 w-10 rounded-full brand-gradient-bg" data-id="element-343" data-mp="kjbrxhi5akxe" />
              <dt className="mt-6 text-[16px] font-semibold tracking-tight text-ink" data-id="element-344" data-mp="145eqlxkd92zt">
                {value.label}
              </dt>
              <dd className="mt-3 text-[13px] font-light leading-relaxed text-ink-muted" data-id="element-345" data-mp="v476qkilk4p9">
                {value.detail}
              </dd>
            </motion.div>)}
        </dl>

        <ul className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-346" data-mp="le43zslobcdq">
          {PILLARS.map((pillar, i) => <motion.li key={pillar.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease
        }} className="rounded-3xl border border-ink/[0.07] bg-white p-9 shadow-soft transition-shadow duration-300 hover:shadow-card sm:p-10" data-id="element-347" data-mp="q4khtdtep00m" data-mpi={i}>
              <span className="grid h-11 w-11 place-items-center rounded-2xl bg-gradient-to-br from-electric/12 to-violetd/12 ring-1 ring-inset ring-ink/[0.06]" data-id="element-348" data-mp="7d1f783annz4">
                <pillar.icon aria-hidden="true" className="h-5 w-5 text-violetd" strokeWidth={1.6} data-id="element-349" data-mp="3qk7zzaw6ws53" />
              </span>
              <h3 className="mt-7 text-[17px] font-semibold tracking-tight text-ink" data-id="element-350" data-mp="3hrmgttoncjfq">
                {pillar.title}
              </h3>
              <p className="mt-4 text-[14px] font-light leading-relaxed text-ink-muted" data-id="element-351" data-mp="3ctky59v4um4s">
                {pillar.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}